import { useSelector } from 'react-redux';
import { Caption } from 'ui/theme/typography';
import { getEdges, getNodes, getWorkflow } from 'modules/workflows/ducks';

export const WORKFLOW_DETAILS_ID = 'workflow-details-id';

export const JourneyDetailText = () => {
  const workflow = useSelector(getWorkflow);
  const edges = useSelector(getEdges);
  const nodes = useSelector(getNodes);

  const { id: workflowId } = workflow;
  const tilesConnected = edges.length + 1;
  const nodesUsed = nodes.length;

  return (
    <Caption data-test={WORKFLOW_DETAILS_ID}>
      ID: {workflowId}&nbsp;•&nbsp;
      {tilesConnected > 1
        ? `${tilesConnected} tiles connected (${nodesUsed} on canvas)`
        : `${nodesUsed} tile${nodesUsed === 1 ? '' : 's'}`}
    </Caption>
  );
};
